import React, { useState } from 'react';

// ─── Pricing Page ─────────────────────────────────────────────────────────────
function PricingPage({ setTab, authUser, vendorProfile, userEvents, setShowAuthModal, setShowContactModal }) {
  const isVendor = !!vendorProfile;
  const isHost = userEvents && userEvents.length > 0;
  const [activeTab, setActiveTab] = useState('vendor');

  const vendorPricing = (
    <>
      <h3 style={{ fontSize:13, marginBottom:8, color:'#7a6a5a', letterSpacing:1, textTransform:'uppercase' }}>FOR VENDORS</h3>
      <div className="info-box" style={{ marginBottom:20 }}>Currently free during beta — $15/month once billing activates. Cancel anytime.</div>
      <div className="pricing-grid">
        <div className="pricing-card">
          <div className="pricing-type">Vendor</div><div className="pricing-name">Basic Listing</div>
          <div className="pricing-price">$15</div><div className="pricing-period">per month</div>
          <ul className="pricing-features"><li>Profile in vendor directory</li><li>Photo gallery (up to 6)</li><li>Insurance & doc uploads</li><li>Matched to events in your radius</li><li>Lead notifications by email</li></ul>
          <div style={{fontSize:11,color:'#a89a8a',marginTop:12,textAlign:'center'}}>All prices subject to applicable sales tax.</div>
        </div>
      </div>
    </>
  );

  const hostPricing = (
    <>
      <h3 style={{ fontSize:13, marginBottom:20, color:'#7a6a5a', letterSpacing:1, textTransform:'uppercase' }}>FOR HOSTS & EVENT ORGANIZERS</h3>
      <div className="pricing-grid">
        <div className="pricing-card">
          <div className="pricing-badge" style={{ background:'#d4f4e0', color:'#1a6b3a' }}>ALWAYS FREE</div>
          <div className="pricing-type" style={{ marginTop:8 }}>Host</div><div className="pricing-name">Self-Service</div>
          <div className="pricing-price">$0</div><div className="pricing-period">forever free</div>
          <ul className="pricing-features"><li>Unlimited event postings</li><li>Full vendor directory access</li><li>Vendor names, photos & profiles</li><li>Send unlimited booking requests</li><li>Contact info revealed on acceptance</li><li>In-app messaging</li></ul>
        </div>
      </div>
      <div style={{textAlign:'center',marginTop:24,padding:'16px 20px',background:'#fdf9f5',border:'1px solid #e8ddd0',borderRadius:10}}>
        <p style={{fontSize:13,color:'#7a6a5a',lineHeight:1.6,margin:0}}>South Jersey Vendor Market is a matching and discovery platform. All event fees, service rates, and event contracts are negotiated and paid directly between vendors and hosts — not through this site.</p>
      </div>
    </>
  );

  // Logged-in vendor only — show vendor pricing
  if (authUser && isVendor && !isHost) {
    return (
      <div className="section" style={{ maxWidth:1000 }}>
        <div className="section-title">Your Vendor Pricing</div>
        <p className="section-sub">Your pricing plan as a registered vendor.</p>
        {vendorPricing}
      </div>
    );
  }

  // Logged-in host only — show host pricing
  if (authUser && isHost && !isVendor) {
    return (
      <div className="section" style={{ maxWidth:1000 }}>
        <div className="section-title">Your Host Pricing</div>
        <p className="section-sub">Pricing plans for event hosts and organizers.</p>
        {hostPricing}
      </div>
    );
  }

  // Not logged in, or logged in but no role yet — show tabs
  const tabStyle = (t) => ({
    flex:1, padding:'12px 0', fontSize:14, fontWeight:700, cursor:'pointer', border:'none',
    fontFamily:'DM Sans,sans-serif', letterSpacing:0.5, transition:'all 0.2s',
    background: activeTab===t ? '#1a1410' : '#fff',
    color: activeTab===t ? '#e8c97a' : '#7a6a5a',
    borderBottom: activeTab===t ? '3px solid #e8c97a' : '3px solid transparent',
  });

  return (
    <div className="section" style={{ maxWidth:1000 }}>
      <div className="section-title">Simple, Transparent Pricing</div>
      <p className="section-sub">Select your role to see the pricing that applies to you.</p>
      <div style={{ display:'flex', borderRadius:'10px 10px 0 0', overflow:'hidden', border:'1px solid #e8ddd0', borderBottom:'none', marginBottom:0 }}>
        <button style={tabStyle('vendor')} onClick={()=>setActiveTab('vendor')}>I'm a Vendor</button>
        <button style={tabStyle('host')} onClick={()=>setActiveTab('host')}>I'm a Host</button>
      </div>
      <div style={{ border:'1px solid #e8ddd0', borderTop:'none', borderRadius:'0 0 10px 10px', padding:'32px 24px', background:'#fff', marginBottom:32 }}>
        {activeTab==='vendor' ? vendorPricing : hostPricing}
      </div>
      {!authUser && (
        <div style={{ textAlign:'center', marginTop:8 }}>
          <p style={{ color:'#7a6a5a', fontSize:14, marginBottom:16 }}>Log in or create an account to get started.</p>
          <button className="btn-submit" onClick={()=>setShowAuthModal(true)}>Log In / Sign Up</button>
        </div>
      )}
    </div>
  );
}

export default PricingPage;
